export const REDIRECTS_ACTION_OBJ = {
  accept_redirect: "rf_settings_redirect_location",
  accept2_redirect: "rf_settings_accept2_redirect_location",
  decline_redirect: "rf_settings_decline_redirect_location",
  dismiss_redirect: "rf_settings_dismiss_redirect_location",
  timeout_redirect: "rf_settings_timeout_redirect_location",
};

export const REDIRECTS = Object.values(REDIRECTS_ACTION_OBJ);

export const DEFAULT_TITLE_MESSAGE_ACTION = /lorem ipsum dolor sit/i;
